import { useState } from 'react';
import { determineTextWidth } from '@utils/common';
import { useLoadFont } from './fonts-ready.js';
import { useIsomorphicLayoutEffect } from './layout-effect.js';

function useStringLength(str, font, fallback = 10) {
  const [computedStringLength, setComputedStringLength] = useState(() => determineTextWidth(str, font) || fallback);
  const areFontsReady = useLoadFont(`${font.weight} ${font.size}px ${font.family}`);
  useIsomorphicLayoutEffect(() => {
    if (!areFontsReady) {
      return;
    }
    setComputedStringLength(determineTextWidth(str, font) || fallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areFontsReady, str]);
  return computedStringLength;
}

export { useStringLength };
//# sourceMappingURL=string-length.js.map
